import React from 'react';
import Avatar from 'react-avatar';
import moment from 'moment';
import {
 Image,
 Badge,
 Button,
} from 'react-bootstrap';
import { Link,browserHistory } from 'react-router';
import TourDates from './TourDates';
import TourState from './TourState';
import TourToday from './TourToday';
import unpin from '../../../../public/unpin.png';
import pin from '../../../../public/pin.png';

class TourBadge extends React.Component {
  constructor(props) {
    super(props);
    this.getManageBid = this.getManageBid.bind(this);
    this.changeTourPin = this.changeTourPin.bind(this);
  }
  getManageBid(tour){
    const url = `/tours/${tour.id}/hotels/4`;
    browserHistory.push(url);
  }

  changeTourPin(tour){
    this.props.changePinStatus(tour)
  }

  render() {
    let image = <Avatar name={this.props.tour.name} color="#326a34" size={250} />;
    if (this.props.tour.image) {
      image = <Image src={this.props.tour.image} responsive />;
    }
    const archived = (this.props.tour.state === 'AR');
    const showHotels = (
          (this.props.tour.groups.length !== 0) && (this.props.tour.cities !== 0)
          && !archived);
    const disable = showHotels?false:true;
    const pinVal = this.props.tour.pin_tour?pin:unpin;
    return (
      <div className="col-sm-6 col-md-6 tour-container">
        <div className="tour">
          <div className="pin-unpin-icon">
            <img className="pin-unpin-image" style={{'cursor':'pointer'}} src={pinVal} alt="Pin" onClick={() => this.changeTourPin(this.props.tour)}/>
          </div>
          <Link to={`/tours/${this.props.tour.id}/overview`}>
            <div className="edit-overlay-container">
              <div className="background-test"></div>
              <div className="edit-overlay">
                <h3>Details</h3>
              </div>
            </div>
            <div className="tour-image">
              {image}
            </div>
            <div className="tour-name">
              <h3>{ this.props.tour.name }</h3>
              <h5>{ this.props.tour.tag_line }</h5>
            </div>
          </Link>
          <div className="tour-dates">
            <TourState state={this.props.tour.state} />&nbsp;
            { !archived && (
              <TourDates
                start={this.props.tour.start}
                end={this.props.tour.end}
              />
            )}
            &nbsp;&nbsp;&nbsp;&nbsp;<Button bsStyle="success" disabled={disable} onClick={()=>this.getManageBid(this.props.tour)}> Go To Manage Bid</Button>
          </div>
        </div>
      </div>
    );
  }
}
export default TourBadge;




// WEBPACK FOOTER //
// src/routes/tours/components/TourBadge.js